import React, { useState } from "react";
import "./index.scss";

const CustomTooltip = ({ children, content, position = "top", type="default" }) => {
    const [visible, setVisible] = useState(false);

    const toggleTooltip = (show) => {
        setVisible(show);
    };

    return (
        <div
            className="tooltip-container"
            onMouseEnter={() => toggleTooltip(true)}
            onMouseLeave={() => toggleTooltip(false)}
        >
            {children}
            {visible && (
                <div className={`tooltip-box tooltip-${position}`}>
                    {type === "default" && <div className="scrollabel-div">
                        {content}
                    </div>}
                    {
                        type === "subdomainIpAddress" && <div className="status-container">                            
                            {content.map((data, index)=>{
                                return (
                                    <p className="status-open mx-2" key={index}>{data}</p>
                                )                                
                            })}
                        </div>
                    }
                    <div className="tooltip-arrow"></div>
                </div>
            )}
        </div>
    );
};

export default CustomTooltip;